export enum MigrationStatusFilter {
  NONE = "none",
  FROM_MB1 = "FROM_MB1",
}
